const PREFIX = "pl-bill-primitives";

export const PL_BILL_PRIMITIVES_TEST_IDS = {
    WRAPPER: `${PREFIX}-wrapper`,
    TEXT: `${PREFIX}-text`,
    ICON: `${PREFIX}-icon`,
    BUTTON: `${PREFIX}-button`,
};
